import {
  ButtonGroup,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
  PrimaryButton,
  Stack,
  Text,
} from "@certn/cascadia-react";
import { Trans, useTranslation } from "react-i18next";

interface Props {
  show: boolean;
  onClose: () => void;
}

export function NoQuestionsModal(props: Props) {
  const { show, onClose } = props;
  const { t } = useTranslation();

  return (
    <Modal isOpen={show}>
      <Dialog>
        <>
          <DialogHeader onClose={onClose}>{t("Template empty")}</DialogHeader>
          <DialogContent>
            <Stack>
              <Text style="form/body-primary">
                <Trans>
                  Please choose at least one question or document upload type to
                  proceed.
                </Trans>
              </Text>
            </Stack>
          </DialogContent>
          <DialogFooter>
            <ButtonGroup>
              <PrimaryButton
                testID="close-no-questions-modal"
                onPress={() => {
                  onClose();
                }}
                size="medium"
              >
                <Trans>Close</Trans>
              </PrimaryButton>
            </ButtonGroup>
          </DialogFooter>
        </>
      </Dialog>
    </Modal>
  );
}
